import type {RouteRecordRaw} from 'vue-router';
import {propositionGuard} from '@/router/guards/propositionGuard';

export const locationFinderRoutes: RouteRecordRaw[] = [
  {
    name: 'location-finder',
    path: '/shipments/retail-overview',
    component: () => import('@/views/LocationFinder/LocationFinder.vue'),
    beforeEnter: (to, from) => {
      propositionGuard(to, from, (proposition) => {
        return proposition.enableLocationFinder;
      });
    },
    meta: {
      title: (t) => t('location.locationFinder.title'),
    },
  },
];
